const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');

/**
 * Resolve relative API paths for production when the SPA is not same-origin as the backend.
 * @param {string} path
 */
export function apiUrl(path) {
  if (path == null || typeof path !== 'string') return path;
  if (/^https?:\/\//i.test(path)) return path;
  const p = path.startsWith('/') ? path : `/${path}`;
  return API_BASE ? `${API_BASE}${p}` : p;
}
